import { useEffect } from 'react';
import { useActionsContext } from './ActionsContext';
import useWizard from './useWizard';
/**
 * Set footer actions for this step.
 * @param {Object} stepActionsConfig useStep
 * @param {(string|number)} stepActionsConfig.id Your steps unique ID, used for navigation.
 * @param {object} stepActionsConfig.footerActions Object of footer actions, meant to be spread over Carina buttons.
 */
var useStepActions = function (_a) {
    var id = _a.id, footerActions = _a.footerActions;
    var activeStep = useWizard().activeStep;
    var setFooterActions = useActionsContext().setFooterActions;
    var _b = useWizard(), canGoForward = _b.canGoForward, canGoBack = _b.canGoBack, goForward = _b.goForward, goBack = _b.goBack;
    useEffect(function () {
        if (footerActions && id === activeStep) {
            setFooterActions(footerActions);
        }
        else if (id === activeStep) {
            setFooterActions({
                start: [
                    { text: 'Back', disabled: !canGoBack, onClick: function () { return goBack(); } }
                ],
                end: [
                    {
                        text: 'Next',
                        disabled: !canGoForward,
                        onClick: function () { return goForward(); }
                    }
                ]
            });
        }
    }, [
        id,
        activeStep,
        footerActions,
        setFooterActions,
        canGoBack,
        canGoForward,
        goBack,
        goForward
    ]);
};
export default useStepActions;
